import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ForbiddenComponent } from "@modules/forbidden/forbidden.component";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'private-area',
    loadChildren: () => import('./modules/private-area/private-area.module').then(m => m.PrivateAreaModule)
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./modules/edit-password/edit-password.module').then(m => m.EditPasswordModule),
    data: { process: "ResetPwd" }
  },
  {
    path: 'expired-password',
    loadChildren: () => import('./modules/edit-password/edit-password.module').then(m => m.EditPasswordModule),
    data: { process: "ExpiredPwd" }
  },
  {
    path: '**',
    component: ForbiddenComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot([...routes], {
      enableTracing: true,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
